
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Tyhjä`,
'deleteKey': `⌦ Poista`,
'downKey': `↓ Alas`,
'endKey': `⤓ Loppu`,
'enterKey': `Kirjoita`,
'escapeKey': `⎋ Pako`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Luo 
          <code>LICENSE 
          </code> tiedosto 
        `,
'homeKey': `⤒ Etusivu`,
'keyCommand': `⌘ Komento/Win`,
'keyControl': `^ Valvonta`,
'keyOption': `⌥ Vaihtoehto/Alt`,
'keyShift': `⇧ Vuoro`,
'leftKey': `← Vasen`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Oikea`,
's00065e45db8c0441': `Katso lisätietoja kehittäjän työkaluista`,
's001dd78415a91fa0': `Vierityspalkin kouru`,
's002fa7d1054ed082': `Rajauslaatikko`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazakstan`,
's01b56d233c6c5cac': `Leikkaus`,
's01d32b35baa3b676': `Kirjoittaja`,
's02106cc2ef0e7578': `Uusi tappi...`,
's02ab1ea8e5100fc1': `Merkitse valinta 'kaksisuuntaiseksi ohitukseksi'.`,
's0312976fe9da5951': `Nappi`,
's03608a32f05eded2': `Nipistyszoomaus`,
's036d35e03be98d22': `Matematiikan syvyys`,
's037b1dc850a89273': `Vaihtoehtoinen alle`,
's0396202b716732ec': `Merkitse valinta läpikäytäväksi`,
's03f49e598ffb11cc': `Puolan`,
's0448f1059fa01720': `Tallenna, jaa tai tulosta tutkimuskohteesi. Muokkaa tietoja, kuten otsikkoa, kieltä tai lisenssiä.`,
's0458872c43beadef': `Lisää rivi ennen`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Sanaväli`,
's05e9759cfd99c48f': `Oikeuttaa`,
's063fa5a0a4903bf4': `Sivuttain, vasemmalta oikealle`,
's064339c229374050': `Koodaus`,
's06634274f19b0572': `Nastojen valinta`,
's06743b24499f0035': `Ankkurikeskus`,
's07808b0ca6da8fef': `Aidattu verkkosivusto`,
's07970793b21351fd': `Ruby-perussäiliö`,
's079cf7850d9327f0': `Fontti`,
's07aa10850d9ddcc7': `Lomake`,
's07e6118e838b2e23': `Navigointi`,
's0816468df86e4036': `Avaa asetukset`,
's082869038c117fe5': `portugali (Brasilia)`,
's086e6c267ade2609': `Saturaatio`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Lisää lista (järjestämätön)`,
's09c3f1d21de14ae1': `Merkitse valinta alleviivatuksi`,
's0a2d91c6720033e9': `Tekstivälileikkaus`,
's0a3ddcba94027d95': `Kohteen sopivuus`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Lisää navigointi`,
's0a7db790db1fc45c': `Merkitse valinta spaniksi`,
's0b1271f50a77dc73': `Sisältölaatikko`,
's0b24d08ea349b455': `Kaikki mitä voit lisätä. Alussa ovat ei-interaktiiviset elementit, kuten luettelot tai kuvat, ja seuraavaksi interaktiiviset elementit, joita kutsutaan widgetiksi. Saat uusia elementtejä napsauttamalla hakupalkkia.`,
's0b7ae9543c001867': `Vastaa`,
's0bdca49248ba4820': `Shortcuts`,
's0befccf152b6c0a9': `Orientoituminen metatiedoista`,
's0c11e479416c8421': `Lisää taulukon kuvateksti`,
's0c27336067c59611': `Vierityksen pehmuste`,
's0c4593d81f147042': `Perustaso`,
's0c4b2e98d4ab7f5a': `Sovelluksen komennot`,
's0c883713b83616a8': `Tallenna aktiivinen asiakirja`,
's0ca5c0460199cba1': `Lyhenne`,
's0cf10c4f40588f8d': `Taulukon kuvateksti`,
's0d86afa3c6a1e28b': `Joustosuunta`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Tutkittava asiakirjasi. Voit kirjoittaa tekstiä ja kopioida/liimata, muokata jne. tänne.`,
's0dc07f97c821463c': `Kommentin valinta`,
's0dc452999c129e15': `Ota live-uudelleenlataus käyttöön`,
's0de0febab8a4beaf': `Virhe tämän paketin lukemisessa`,
's0e44968489e076a8': `Kiinalainen`,
's0e4862e87c7d53ce': `Merkitse valinta lainaukseksi`,
's0e6ea8870dbddab2': `Asiakirjan komennot`,
's0ee28503778e4c0c': `Viimeisin perustaso`,
's0ef01c03299bbb83': `Koristelu`,
's0f17f32919661cff': `Mongolian`,
's0f350bc4e538e3ea': `Sanat`,
's105540b7756c0232': `Määritelmä termi`,
's105a06836c40fcb4': `Aseta suodattimet, väri ja valittujen elementtien sekoittaminen.`,
's106b274b5af798e5': `Lauseet`,
's1082e1649793dca9': `Merkitse valinta määritellyksi termiksi`,
's10f3845975a0351e': `Muokkaa metatietoja`,
's1125d159f7e64df5': `Näyttö`,
's11326fd2590f4e5e': `Oletus`,
's1155ec07a221e739': `Vierityspalkki`,
's1173bf7a3e0b74c9': `Vähimmäisarvo (y)`,
's1177237a3e0e548c': `Vähimmäisarvo (x)`,
's1219d97b49650c05': `Näkyvyys`,
's123bea44f38abccf': `Lisää objekti`,
's1245e2cb9f20197e': `Kohdista`,
's12946ec1b850962c': `Lisää sarake jälkeen`,
's1351209ef74ee729': `Kaikki sarakkeet`,
's13c60cb409e8cb6f': `Kohdista keskelle`,
's13ebd619c8a06a6d': `Ruudukon automaattiset rivit`,
's13ef8ca26ca8861b': `Leikkaa elementti`,
's151349210ac1d2d8': `Lisää ryhmä`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Pöydän pää`,
's156647179b21d351': `Lisää taulukon runko`,
's158b6ec6b1fffcb2': `Tauko jälkeen`,
's15d0c0657c1ee08c': `API-avain`,
's1626a7e10a9f9dcc': `Asettaa valinnan kirjasinperheen`,
's1637c7d1a30629e2': `Border Box`,
's1641ab440bf4daa4': `Päivitä tämä widget-paketti`,
's166bd56d19670a72': `Zoomaus`,
's1696c76a23c0834e': `Edistynyt: Näytä paketit, joiden versiot ovat 0.x.x.x, paketinhallinnassa.`,
's16b9446e3a70e1f4': `Attribuutit`,
's16f205466761e583': `Ei optista fonttikokoa`,
's16f2f1c2c516d307': `Avaa asiakirja`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Lisenssi`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Poista kenttä`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Luo paketti`,
's18d5c44aae3dc82a': `Verkossa muokattaessa`,
's1988d71ef8060edf': `Lisää taulukkorivi`,
's19abee1277c9bca2': `Samoalainen`,
's19daf2f26c19543d': `Luonnos`,
's1a1acc902e6668e0': `Näytä edistynyt tekstin muotoilu`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Pylväsväli`,
's1af8b67d1c85c811': `Välitila`,
's1b4a36fce2456660': `Fonttiperhe`,
's1c246045629b0016': `Merkitse valinta poistettavaksi`,
's1c3fc313a9184670': `Julkinen linkki`,
's1c65f5004a07dcfa': `Skotlannin gaelin kieli`,
's1c690963f1e2df00': `Alustakohtainen ulkoasu`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Haluatko lyhyen, opastetun kierroksen?`,
's1d19244f549ec535': `Koulutus`,
's1d5c7b28e8b50d6d': `Associate deg.`,
's1db591f5a54dbfd3': `Sisältölaatikko`,
's1dbb9f50e16c92a3': `Reunan säde`,
's1dfb744260fb3a01': `Kaksisuuntainen eristys`,
's1e9c2c654732cc5f': `Valko-Venäjä`,
's1eaccbf2d6af8ab5': `Tiedot`,
's1efbfc3937d565bd': `Tausta`,
's1f2b49c1bca2035d': `Katalaani`,
's1f74bdf32b51a5fc': `Taustakuva`,
's1f7698c061c208c9': `Avaa`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsika`,
's21d61916eb8d137d': `Pöydän runko`,
's21d723a1dbcd89c8': `Javanilainen`,
's21f8a2eaf5a70749': `Lisää etiketti`,
's2206c42e5b835e6e': `Merkitse valinta lyhenteeksi`,
's22a2348c46a912a0': `Lisää jakso`,
's233ae776268cd44b': `Liiketoiminta`,
's236ed7ba747099b0': `Fontin paino`,
's2474e7fb1aec9f05': `Testi`,
's2492f5fb1b05b45e': `Teksti`,
's24949d7adbb5a098': `Työkalupakki`,
's252a52330d32b900': `Metatiedot`,
's2540844a4bc4d9ba': `Vaaditaan maininta?`,
's255857544a9d5ec0': `Nollaa`,
's255c77900f2b5e0f': `Värimaailma`,
's256ab831a48c941c': `Poistaa kaikki tekstin muotoilut valinnasta.`,
's2591806d7b222591': `Nollaa muutokset`,
's25e1a07e454c2c11': `Ruutu`,
's262abbaf1d05f009': `Pehmeä valo`,
's266935f2447fcd98': `Yli vasen`,
's268ecd1cef45a9a8': `Oletko varma?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Kevennä`,
's27076e66c5d483ba': `Pystysuora kohdistus`,
's2712dc5641a33226': `Pakettirekisteritilit on tarkoitettu kehittäjille, ja niiden avulla voit määrittää
          yhden tai useamman rekisterin.`,
's2739460e44320108': `Kiina (perinteinen)`,
's27cc88818cc46ff6': `Vakaa`,
's281d957112b10f12': `Muokkaa asiakirjan HTML-koodia suoraan`,
's28b6246ce616a548': `Lisää taulukon sarakeryhmä`,
's29a1c26521879b9f': `Pienennä mittakaavaa`,
's29acfd2778e8c377': `Piilota edistynyt tekstin muotoilu`,
's29b24c06315e9343': `Lisää syöttölaite`,
's29eb103449472e3b': `Lisää otsikko (taso 3)`,
's29ee7434494a0dfe': `Lisää otsikko (taso 2)`,
's29f21c34494d614d': `Lisää otsikko (taso 1)`,
's29fbfc3449557f72': `Lisää otsikko (taso 6)`,
's29ff743449588131': `Lisää otsikko (taso 5)`,
's2a031834495bcdb4': `Lisää otsikko (taso 4)`,
's2a75c946ef4dcab7': `Sekalaiset`,
's2b2ae20d26f78ac2': `Lohko`,
's2b8f50c64be440f7': str`Valitse 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Tilaa`,
's2bad2d24def4aa0b': `Rivinvaihto (CJK lang.)`,
's2ceb11be2290bb1b': `Peruuta`,
's2ced8e8fafb499f6': `Poista elementti`,
's2d986d31f8d67357': `Lisää kenttäjoukko`,
's2d995a37cf5e4995': `Lisää NoScript`,
's2de969afacdaa7a6': `Muoto`,
's2df075aface0dab8': `Jaa`,
's2e192b19ed15fcf6': `Sivu`,
's2e39b99cf23606fa': `Aseta valittujen elementtien asettelu`,
's2e4818861000b13f': `Asettelu`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Ylivuoto (y)`,
's2edd6688a65e21f0': `Ylivuoto (x)`,
's2f0bcdffc92a786b': `Kellu oikealle`,
's2f2044f2431a32d5': `Otsikko`,
's2f4d4bfbc466d91f': `Albanian`,
's2f8da2cb5f236588': `Pakettisi nimi. Sen on oltava rajattu, esimerkiksi \`@org/pkg\`. `,
's30cce87854901922': `Esikoulu`,
's3124653c272f054c': `Sarakkeen säännön väri`,
's314a4f7685c8e824': `Aina`,
's31c06e226322f065': `Vältä orpoja`,
's323dcde72b850272': `Julkinen pääsy`,
's32911e52ee8ac745': `Aseta aukko`,
's337a1e9022a8d19f': `Taulukko`,
's33c1450d2822bb0f': `Kuvion kuvatekstin lisääminen`,
's33c18d5a4cbffa2a': `Irlantilainen`,
's33f85f24c0f5f008': `Tallenna`,
's342b0cabfa672822': `Auta käyttäjää löytämään widget`,
's3437e0d9899e7ae1': `Lähetä telemetriatietoja WebWriterin käytöstäsi.`,
's344ea8f4939cdc98': `Väri`,
's34dcda3b0f9d5a98': `Vaihda url`,
's34f724979a124c50': `Asettaa valitun tekstin taustavärin`,
's355b21b89ce5d9c5': `Yksityiskohdat`,
's35ae5f4e0fa2777b': `Mukautettu kohdistus`,
's35aeaff1425bca9e': `WebWriter ei tue tyyppiä `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Koodi`,
's3649bacefe731bf6': `Vaihda työkalupakki`,
's365280e16a8ea32d': `Kopioi valinta`,
's366991b9c9287765': `Oikea`,
's36a194e38d653a26': `Tietojen merkinnät`,
's36b3cefdcb897f15': `Perspektiivi`,
's372fae706048ce41': `Parillinen`,
's377e24af9628c37e': `Tilattu luettelo`,
's37a8c35f6581da5f': `Ei ankkuria`,
's37fa3b9cd51c2dfd': `Asettaa valinnan fonttikoon`,
's380d17664bb69531': `Lisää sarake ennen`,
's3815184eb09f0dcf': `Kursori`,
's382a2aa3984474dd': `Luo`,
's38980f98cb07ceb8': `Tallenna aktiivinen asiakirja kopiona`,
's3914cb410fca44d4': `Tuo`,
's3a179f6db2972384': `Ruby-asento`,
's3a5ca02f282d247e': `Jaa...`,
's3ae67088bbefba98': `Paketit`,
's3b0ab4b52326316f': `Valo`,
's3bc203a3f8a6409c': `Kielen päivittäminen koko asiakirjassa`,
's3bdad99768e11911': `Tutkittavissa`,
's3cb47df8290fa94c': `Lisää vaihtoehto`,
's3cf89cb47fdde7e9': `Linkki`,
's3d09398e555ee5f9': `Lisäasetukset`,
's3d249bb480032121': `Luettelo`,
's3d3efd1e19bdcfb4': `Päiväys/Aika-merkintä`,
's3d6a732c792ccb9e': `Ruby-merkintä`,
's3d93f9ea0c5a13fa': `Kuva`,
's3d9548e211b958ce': `Päällekkäisyyksien ohittaminen`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Nätti`,
's3eb6d1e6e79ed7c4': `Asiakirjoja ei löytynyt`,
's3eca5a034978754b': `Poista valinta`,
's3f06e9abb6ebcb79': `Hahmot`,
's3f1e7a3f2b283d3b': `Marginaali`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Lisää artikkeli`,
's3fd83566dd643d10': `Legendan lisääminen`,
's3fe72792941c18f9': `Teksti pohja`,
's3ffcdc5db5e7d0c5': `Käänteinen`,
's40e3826b7f74a3b5': `Pan (oikealla)`,
's40f07d7859284a44': `Vallitseva lähtötaso`,
's4101ada154a1b958': `Keskimmäinen`,
's410c465a5993f82d': `Rivinvaihtomahdollisuus`,
's41322d19c928c603': `TIETO- JA VIESTINTÄTEKNIIKKA`,
's417b90913e05bc17': `Esikatselu`,
's418f2020fe996832': `Vahvista muutokset`,
's41c724f0698148e9': `Merkitse valinta pikanäppäimeksi`,
's41f65a763f8e44ab': `Taulukon otsikkoryhmä`,
's42721130228841b0': `Aivohalvauslaatikko`,
's429bd646f1cf8bc6': `Kielioppi LLM -tilien avulla voit käyttää Kielioppi LLM API:ta tekstin kieliopin korjaamiseen.`,
's429dd933ba95549b': `Lisää osoite`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Lisää rivi jälkeen`,
's430831017f3f0499': `Vinous (y)`,
's430bd5017f42511c': `Vinous (x)`,
's433ba70286202ceb': `Riko kaikki`,
's441b20a8a50e36b4': `Makedonia`,
's445b8acb9206db6e': `Hylkää ja peruuta`,
's446a924922651ea0': `Tekstin korostus`,
's44cdba92713de38e': `Ruutualue`,
's45518abd911471d0': `Kroatian`,
's456a8d744313852a': `Tilaa ympärillä`,
's4634541f5056a546': `Abhasian`,
's46d4abe6255cb9e1': `Määritä pikakuvake uudelleen`,
's4730c232e7209c40': `Leikkaa molemmat`,
's474f0eec369d02a4': `Näytteen ulostulo`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Merkitse valinta päivämäärä-/aikamerkinnäksi.`,
's47ebf3a8fb3b10c1': `Orientaatio`,
's4802bb8eb52fbdeb': `Portaali`,
's4802e47fe2e95134': `Vaihtoehto`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Tekstin varjo`,
's4993444bfd3f3e5e': `Romahdus`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Naamio`,
's49dd67aed00029ef': `Matematiikka`,
's49e763aed00877a8': `Main`,
's4a894f57eba1cf1e': `Näppäimistön pikavalinta`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Kova valo`,
's4b2c143acf931122': `Viivan korkeus`,
's4b58c01e2578f5e4': `Selite`,
's4bbff4e008690da1': `Vältä sivua`,
's4c402ff5355fd310': `Kaksisuuntainen ohitus`,
's4caed5b7a7e5d89b': `Englanti`,
's4cb38675a21b2c98': `Ei tuettu ominaisuustyyppi '\${desc.type}' (käsittely JSON-muodossa)`,
's4cc8391f172c0cdf': `Poistukaa kiertueelta`,
's4ce8cc041a628847': `Kun asiakirjan kieltä muutetaan, päivitä kaikkien widgettien kielet vastaavasti.`,
's4d528b416ac8dee2': `Lisää otsikkoryhmä`,
's4d546f6c87128d5b': `Avaruus ensin`,
's4dcb9315f6527f9c': `Suorita uudelleenlataus`,
's4e191bdb4700a6e9': `Ylikierros (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Virhe yhteyden muodostamisessa`,
's4e361bf8eef3759a': `Sanatauko`,
's4ea0f21fc2a338a1': `Siirry ylöspäin`,
's4eace13b3ed74187': `Sivukommentti`,
's4efee5b48a4593cb': `Silmukka`,
's4f26e7cb7c0a8318': `Vektoripiirustus`,
's4fd2e638aabb0bb3': `WebWriter tukee monien eri lähteiden upottamista. Liitä vain linkki sisältöön
          osoitteesta:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Ohut`,
's50489ffb1bde152e': `Asettaminen`,
's5068560b8d39663d': `Klikattava kartta`,
's517acbf1f96324f9': `Paino`,
's523eb9043213ff0d': `Kursivoitu`,
's52777d434baeed9b': `Aseta edistymisindikaattori`,
's52af5d7ac34c2163': `Taulukko Rivi`,
's52e0bdc3ee304436': `Aseta mittari`,
's52fb1524cb25d7ab': `Uusi säie`,
's531056f039febd39': `Lisää valintamerkki`,
's536695196d0b6dc3': `Färsaaret`,
's542fcefa0bbaed86': `Avaa tai sulje työkalupakki (vain kapeilla näytöillä, muuten työkalupakki näkyy aina sivulla).`,
's5432ad3c84273229': `Kuva`,
's543906d1db8b2283': `Muokkaa `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodža`,
's54897f2764b0e4d0': `Asenna tämä widget-paketti`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Merkitse valinta erittäin tärkeäksi`,
's55905c735052d295': `Temaattinen tauko`,
's5590dbf7e425789d': `Tarra`,
's5623aa2f83b05c76': `Tiibetiläinen`,
's564d1648b1ceee9f': `Ajan tasalla`,
's565cd5ffb0158c46': `Vältä aluetta`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Palaa takaisin`,
's5787c6d5b3b5541a': `Leikkeen polku`,
's579c69f419b6caef': `Sileä`,
's587ac858dd80f6fa': `Alaindeksi`,
's58bec0ecd4f3ccd4': `Tiukka`,
's59404f5593c32fdc': `Fontin kerning`,
's5941292bb77281ab': `Norjalainen Bokmål`,
's599dcd2472c75c19': `Kohta`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Merkitse valinta tietomerkinnällä`,
's5a356677b61a6b7e': `Moldavian`,
's5b474b5c0ac0c7c4': `Taulukon sarakeryhmä`,
's5b517ac216f9ee62': `Sivuttain`,
's5b8cc9bb61ddce15': `Lisää kohta`,
's5bba2ac2e53bd1fd': `Kirgisia`,
's5be80ad6b8301710': `Inline-käynnistys`,
's5c1ecf88259b79f9': `Esittely`,
's5c2a1a52c0389c30': `Insinöörityö`,
's5c63af7695445fcf': `Tekstityyli`,
's5d18ca4c3111be6f': `Lisää taulukon otsikko`,
's5d87c1e588f48d90': `Harjoitus`,
's5d929ff1619ac0c9': `Etsi`,
's5da52af9b083c29a': `Malli`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Kirjaudu sisään`,
's5e2cba97c0d971bd': `Lataa paketit uudelleen`,
's5e53415a6d5719ad': `Yhteiskuntatieteet`,
's5e6a7a0c30d2a270': `Päällekkäisyyksien ohittaminen (automaattinen)`,
's5e9e8e4d21bafedc': `Elintarvikkeiden tuotanto`,
's5ed03bb1f3a15949': `Kuva`,
's5f43af3669b1e098': `Lähde`,
's5feaf7fd7ee567c8': `Tauko sana`,
's600fd23c9ce971e8': `Tulosta aktiivinen asiakirja`,
's602bbd28dae2c60f': `Itse käynnistys`,
's60ff598dfcf2c773': `Oikealla`,
's61053f0e3ebbd272': `normaali`,
's613c6ff83883c04f': `Taulukko Sarake`,
's6196153c4b0c1ea0': `Asenna`,
's61c017f6d5c303af': `Friisin kieli`,
's61ded17ca3f48c82': `Alleviivaus offset`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Kopioi valinta`,
's624e31cd4f1b89d4': `Sileä vieritys`,
's626daf42b1ab7df7': `Kohdista vasemmalle`,
's6280bf993915c57a': `Vieritysmarginaali`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Kuvaus`,
's63dfc5b1c1c27849': `Jiddish`,
's63e03c70f67ebf9c': `Konteksti`,
's63e71d20d1eaca93': `Saksan`,
's640bc7710d0143ce': `Viimeisimmän peruuntuneen muutoksen palauttaminen aktiivisessa asiakirjassa.`,
's64dc1fc7e3db45c9': `Luo uusi asiakirja`,
's65ac276544ba33cd': `SVG-tiedosto`,
's66765c420ee578e4': `Tilaa tasaisesti`,
's669b18c6d2d9c95b': `Ei ole`,
's6747dbf4ad6063ba': `Itsenäinen loppu`,
's6787497df07fa97e': `Voi selata pysäkkien yli`,
's67c2b60a506a09e4': `Toisen asteen koulutus.`,
's680bd4d926cd5a84': `Säilytä 3D`,
's6827930ef1aeaf99': `Perus URL-osoite`,
's684a16f3c711394d': `Yli oikealle`,
's687e27f036a71b32': `Eristä`,
's68b87d7b61052dc3': `Taulukon rivi`,
's68e0e3a2bab7ce3e': `Vältä`,
's690da6b432987c6f': `Varmuuskopioi muutokset nykyiseen asiakirjaan automaattisesti. Muutokset palautetaan, kun WebWriter ladataan uudelleen.`,
's69311c4e25074fb3': `Lukio`,
's697400b541fbc3cd': `osoitteessa`,
's6988ab5d47593a26': `Sinulla on WebWriterin uusin versio.`,
's69a49786a8009f43': `Etsi paketteja...`,
's69b12144dbb6544d': `Laosin`,
's69d88ef4b2618980': `Kansi`,
's69fbbdb8ad2a084a': `Darken`,
's6a31eff1ec4f71ad': `Piilota takapuoli (3D)`,
's6ac62e1c8c66f3bb': `Kompakti superscr.`,
's6b585ba37cdb8260': `Peritään`,
's6b61f8abf89586be': `Heprea`,
's6bd7a02fdf93e653': `Kohdista sisältö`,
's6cfc66b824ea05ba': `Terävät reunat`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamilainen`,
's6d8b3b8047ed378d': `Sekoita sekoitustila`,
's6d8c02aee480af7a': `Valikko`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Lisää tyyli`,
's6e288a119281f4c2': `Tekstin esittäminen`,
's6e4c20c6debcd5ca': `Mukautettu perustella`,
's6f84199e62584905': `Esimuotoiltu teksti`,
's6fb3053e7244d326': `Muut alat`,
's70178e04a3b691b6': `Avaa asetukset`,
's7031ca562378bde6': `Geometrinen tarkkuus`,
's7060970b5ed20a58': `Vuorovaikutteisuus`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Näytä epävakaat paketit`,
's71dec51005acc1e4': `Rivi tiheä`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Kohde`,
's731678e227a20559': `Tämä laite`,
's736904f276fbd441': `Luonnontieteet`,
's739544d0c858c633': str`Tai pudota 
          ${0} tänne 
        `,
's73cb20c838e761e1': `Leikkauksen valinta`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pikselöity`,
's743f778233e42a3f': `Lisää sivulause`,
's744d993d03f29851': `Näyttö`,
's74540c1b595a229c': `TeX-kaava`,
's748c0074eff45884': `Manipulointi`,
's74aa0039a87141e2': `Ellipsis`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Täytä laatikko`,
's75109f5307578a61': `Tervetuloa WebWriteriin`,
's75a27f43413e02c5': `Ranskan`,
's75d83fc3f0cfab40': `Otsikko`,
's762e5704cc84089d': `Aseta muiden valittujen elementtien tyyliasetukset`,
's77318393dfdb0775': `Poista rivi`,
's77e594ddcc10c774': `Sallitaanko kaupallinen käyttö?`,
's780099588362f80f': `Määritelmäerä`,
's782eac2b3e80323d': `Merkitse valinta korostetuksi`,
's782f286a79cca35d': `Suhteellinen`,
's78673a3539cb1915': `Ylhäällä vasemmalla`,
's78789724e789221c': `Koko`,
's789ff24c8f03f1a4': `Kirjainväli`,
's7995733bf97c01cc': `Serbokroatia`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Virhe kanssa `,
's7ae49e142487766c': `Yhteisön pääsy`,
's7af555180b30a947': `Avaa kehittäjätyökalut`,
's7b4ba250601b8667': `Lisää malli`,
's7b560d8693ed8f42': `Pystyasennossa`,
's7b9994904c4f5b54': `Tadžikistan`,
's7bdf0fd5b014d36c': `Vahva merkitys`,
's7beb1e77e82363eb': `Aktiivisen asiakirjan viimeisimmän muutoksen peruuttaminen`,
's7c61118554a0ec36': `Suurin (x)`,
's7c95876637f6a9d7': `Suodatin`,
's7cb4e55c59663b1c': `Yritys`,
's7cfe12cd14df9950': `Kirjaudu ulos`,
's7d27db3c9639c6dd': `Vaihtoehtoinen`,
's7d8103f6f06f83d6': `Pehmuste`,
's7d864465dddbb50d': `Salli koon muuttaminen`,
's7de0e28d6c309a4e': `Salli kosketustoiminnot`,
's7dea785045c3cc74': `Paina uutta näppäinyhdistelmää...`,
's7e0b179d4d1414eb': `Kirjoita linkki`,
's7e6570f2f1ae320f': `Syntetisoi kirjasintyyppejä`,
's7ecb1f29332293e5': `Kohdistamisen perustaso`,
's7ed13ccddb1bf3c3': `Overlay`,
's7edbe0b213199995': `Kandidaatin`,
's7ede1c55e35ce9d6': `Simulointi`,
's7f09197a4814079b': `Aseta vuorovaikutteisuusasetukset valituille elementeille`,
's7f326a142e856656': `Tyyli`,
's7fcb35d23be1e643': `Kenttäjoukko`,
's80570196a9ce6d11': `Ota telemetria käyttöön`,
's806f84eb0ace116e': `Katso, mitä olet valinnut, ja muuta sitä. Kopioi, leikkaa, liitä, kiinnitä tai tee asettelumuutoksia. Tarjoaa erilaisia vaihtoehtoja valintasi mukaan, esim. tekstin muotoilua.`,
's80a42b81c52d4d8f': `Karetin väri`,
's80b71fc6f43c5ce1': `Löysä`,
's812cbda653daaeba': `Tätä ominaisuutta ei ole vielä toteutettu`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Jatka`,
's8247d32213e35f24': `Aseta tärkein`,
's82665b2ffabc9c0a': `Verkkosivusto`,
's828b1ecea8715884': `Pan (vasen)`,
's833bd0422a7ef95d': `Välilehden koko`,
's83420ad7b6a14db5': `Toggle Dev-työkalut`,
's83c15613b6f6f3c8': `Vain verkossa`,
's83cd32b685ccc9b7': `Ohjaimet`,
's83f26d02dd7aa681': `Näkyvä`,
's840fa49e8989c028': `Asento/muoto`,
's844a76d1843ceb3c': `Palauta oletusasetuksiin`,
's84e4e8ae645b82ac': `Yläoikealla (y)`,
's84e9c7f8785ca60b': `Lisää lomake`,
's8517ae4da104b004': `Taulukon sarakeryhmä`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Lisenssi Creative Commons OER?`,
's85f9aa6d3ea0e421': `Taulukon alatunnisteen ryhmä`,
's864b0e6270e97246': `Merkitse valinta sivuhuomautukseksi`,
's8670e5ad3bf0dcf8': `Tallenna nimellä`,
's8688d74dd3716d6e': `Komentojen näppäinpikanäppäimet`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Muotoilun marginaali`,
's87cefc710b3567fb': `Sisältää`,
's88676f992b2965db': `Solun sisällön venyttäminen`,
's886897f2fd4edb99': `Piilotettu`,
's886c5db2a5579873': `Konsepti`,
's888c71e8fcb916d3': `Automaattinen tallennus`,
's88a62d29529948fb': `Lisää taulukko`,
's89950d86c8004d4b': `Ohita ei päällekkäisyyksiä`,
's89bca7498f20e041': `Tausta Clip`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Tauko ennen`,
's8a4ff2bd9c13498c': `Record`,
's8a6585c48ea104e9': `Piilota tyhjät solut`,
's8a9eb438abac7c6a': `Tarrat`,
's8b0432eecbd8b034': `Päivitys`,
's8b7580c35e2aef87': `Ylhäällä vasemmalla (y)`,
's8bc4affa761aa8a2': `Kuvan lisääminen`,
's8c7f51cb067644c7': `Tietoluettelo`,
's8d342ecaa9e75b9b': `Suhde`,
's8d797888455f4147': `Taukotilat`,
's8d83386457e91813': `Peruuta/palauta muutokset tai esikatsele oppijan näkökulmasta.`,
's8d8643013a7754d1': `Kohdista teksti`,
's8df30fe2a50d3479': `Lisää rivinvaihtomahdollisuus`,
's8e715248c3a78446': `Leikkaa valinta`,
's8f29e48d6b9a1aa8': `Lisää taulukon otsikkorivi`,
's8f4be9f086eb530f': `Kumoa`,
's8f533296a536965e': `Tallenna nimellä...`,
's8fad58c831ecf017': `Ruby-tekstisäiliö`,
's8ffe7abcbed8eb43': `Pystysuora, vasemmalta oikealle`,
's90105521fcc40453': `WebWriter Cloud -tilien avulla voit tallentaa asiakirjoja verkossa ja jakaa niitä
          oppilaiden kanssa. Lisää tili täällä, niin se on käytettävissä sijaintina asiakirjojen
          tallentamiseen, lataamiseen, jakamiseen ja avaamiseen.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Fonttipaletti`,
's90f7c1cf501ea0a7': `Väri väistää`,
's91093e0b087911ba': `Painotusasento`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Lisää upottaa`,
's9219acd5bef6269e': `Vasemmalla alla`,
's92548405912d46bf': `Selauspainikkeen kohdistaminen (y)`,
's9258280591309342': `Vieritysnapin kohdistaminen (x)`,
's927d796559f49439': `Tausta Alkuperä`,
's92b177e579ef7b97': `Painotus`,
's92f846b9be2e8e8d': `Merkitse valinta kursiiviksi`,
's93566b84230af4f5': `Kuvan lisääminen`,
's936aa0b239679585': `Lisää temaattinen tauko (yleensä näytetään vaakasuorana viivana).`,
's9370dc6afa716b57': `Raja`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Määritelty termi`,
's9485af2e7cd9418f': `Peruskoulu`,
's94d2eee44b292567': `Vaihda lisäasetuksia`,
's94d61907ee22a8c1': `Korean`,
's94eb1effbbb6498b': `Ylivuoto`,
's951aa3a6439f1271': `Luettelomerkki`,
's9565553d163fc92a': `Käsikirjoitus`,
's957787fc6b7ea5c0': `Pan (ylös)`,
's95d56e58f816d211': `Hollantilainen`,
's95d8e41a64635c7c': `Valkoinen tila`,
's95de7e1eff6c053e': `Vaakasuora, ylhäältä alas`,
's960d3a90ac199368': `Rhaeto-Romanian`,
's96532132a29dd542': `Lisää ääni`,
's96a045dcade75ad0': `Pylväs tiheä`,
's9781a5bb3fcb26a3': `Valitse ensin yritys`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Riviväli`,
's97aa76056a81bd36': `Mittarit`,
's986facb3ecc9602c': `Sivuttain, oikealta vasemmalle`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Ulkoinen tiedosto`,
's98977a87d1b93941': `Nollaa tiedot, tyylit ja skriptit`,
's98b1cb8fb62909ec': `Ryhmä`,
's990d0e0fa2ab00b5': `Galician`,
's99229574e5692f19': `Grönlantilainen`,
's99a990f3841ad283': `Tiedostot `,
's99b38e000175cc84': `Yliviivaus`,
's99f110d27e30b289': `Otsikko`,
's9ab10fbf4c7a7322': `Alleviivauksen sijainti`,
's9abadcc828884d7b': `Tekstialue`,
's9b7cd8860c8fc922': str`
          ${0}
          ylikirjoitetaan. Oletko varma? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Taustan väri`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Taulukon sarake`,
's9cf68f87b8e6122f': `Azerbaidžan`,
's9d167ef77aed79b6': `Kerros`,
's9d2d00982edafabb': `Turkkilainen`,
's9d430adc5be110e9': `Rivi käänteinen`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Poistaminen`,
's9df571714a1efb44': `Tästä tutkittavasta kohteesta on saatavilla automaattisesti tallennettu versio. Lataa se?`,
's9e28faa598332e2b': `Lisää video`,
's9e3dbb678150edd4': `Aseta kirjasinperhe`,
's9e40e59654c8ad67': `Pylväs`,
's9e85800d3700e31c': `Seuraa`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Fontin variantti`,
's9f1ecdb3061d9cbc': `Säilytä tilat`,
's9faf26107ed49fb9': `Lisää taulukon solu`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Siirtymä`,
's9ff3121d30f88d52': `Normaali`,
's9ffe1bbe64712bf1': `Kangas`,
'sa00df4e39c72d3b4': str`
          ${0} ei tueta 
        `,
'sa013e119fec906fb': `Rivi`,
'sa01e7bf33563ef72': `Taustaliite`,
'sa126cf8c627cec1e': `Kuvan renderöinti`,
'sa13f72278add7513': `Oikealla`,
'sa1647e3b36ec08d7': `Yhdistetään pystyasennossa`,
'sa172190ea21f9b1c': `Pääset asetuksiin, voit avata tutkittavissa olevan pelin tai luoda uuden.`,
'sa1c6c459b9b5115c': `Absoluuttinen`,
'sa2cba871f6cdd99f': `Assamilainen`,
'sa2eff4dad1c119f1': `Ruudukkomalli`,
'sa30c12014e955946': `Venäläinen`,
'sa30f1981fd1cd441': `Kirjasinkoko`,
'sa311a24c1471a974': `Asiakirja`,
'sa352d168b262aa06': `Lisää alatunniste`,
'sa37fee6a52d18063': `Poista asiakirja`,
'sa39c7ac1d37f3bce': `Merkitse valinta 'kaksisuuntaiseksi eristykseksi'.`,
'sa3b4c01623211544': `Voima`,
'sa40fd43756fa8913': `Persialainen`,
'sa417644bef21a9aa': `Nimetön teema`,
'sa43800e28be1bdbc': `Koristeen väri`,
'sa477cb1825dceb3b': `Sudanilainen`,
'sa492a51a707930fa': `Lisää lohkoviittaus`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Kuvateksti alareunassa`,
'sa50d3c35533f1d99': `Kaikki kentät`,
'sa53c5cb03a8fda50': `Kiinnitä valinta paletissa olevaksi pätkäksi.`,
'sa557ae6bee9148a6': `Progress`,
'sa589e1df65dde0ec': `Aseta valittujen elementtien koko, pehmusteet ja marginaalit.`,
'sa5c371b4bb75e590': `Vasen`,
'sa5c80e623459ffe4': `Lisää otsikko`,
'sa5df1bcdba46c3fb': `Kuva Kuvateksti`,
'sa602e3fd3f2d98fd': `Animaatio`,
'sa644d580d8a11e60': `Rubiinin kohdistus`,
'sa645d315510dc09e': `Valitse polku levyltä`,
'sa65d4ad99f1d8c06': `Aseta tekstin tausta`,
'sa6607436f60ccc1a': `Viron`,
'sa6f8d27bca557059': `Siirrä meta/linkki/tyylielementit ylös/alas tähän elementtiin.`,
'sa757645ad842da97': `Säilytä taukoja`,
'sa75b95980cd80e78': `Toimittaja`,
'sa7698b3d20a6d1ec': `Scroll`,
'sa778acc33947c7b8': `Kierroksen päättäminen`,
'sa78a67272a4a6f95': `Matematiikan kaava`,
'sa79167651dce1e80': `Vaihtoehtoinen teksti`,
'sa7af797a46c7d09a': `Taulukon alatunniste`,
'sa7dbe35b758c138d': `Lisää kangas`,
'sa7dc6b8ef3f595dc': `Lisää lähde`,
'sa8279f8211b3950d': `Säilytä taukoja ja tiloja`,
'sa8b55cab62e439b5': `Poista sarake`,
'sa8bbe0197d31b423': `Lyhyt kuvaus`,
'sa9ff3b762365abe6': `Muunnoksen origo (z)`,
'saa02e3762368ff35': `Muunnoksen origo (y)`,
'saa065776236bfa28': `Muunna origo (x)`,
'saa33768e03c45fc8': `Tiedoston koko`,
'saaad98061a20ac39': `Lisää matemaattinen kaava`,
'saab875d8cfcfe712': `Teema`,
'saad4380b9cc6cefd': `Vaihtoehtoisesti yli`,
'saaec15c97a9e4245': `Pylväs käänteinen`,
'sab0c57df694a0a09': `Trimmin aloitus`,
'sab4d9283896d9422': `Snap-resoluution pikselit`,
'sab55faae8e165407': `Padding&lt;br&gt; kuten aukko`,
'sab5e7d2a069a2951': `Ammatillinen tutkinto.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Kohdista oikealle`,
'sac895c732f350ac5': `Tumma`,
'saced41ddda8b2354': `Joustoperuste`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompakti matematiikka`,
'sadd352cc7f6f2307': `Sivussa`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Ruotsalainen`,
'sae1c7f13b7c0c47f': `Aloita`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Lisää kuvausluettelo (sanasto, termiluettelo).`,
'saf3da7c95cb17260': `Merkitse valinta ylempänä olevaksi`,
'saf440a0a592f2835': `Päivitys osoitteeseen`,
'saf9e5134ba1a7d30': `Vieritä napsautus`,
'safc6f203342d09e2': `Vaihtaa aktiivisen asiakirjan esikatselun`,
'sb0a7e3adf4a125ee': `Ylhäällä oikealla`,
'sb0a974028c99ca6d': `Sallitaanko mukautukset?`,
'sb0d4f0f7993cf085': `Aseta fonttikoko`,
'sb0f3327210fe18fc': `Sarakkeet`,
'sb0f93c1c60c0249a': `Rubiinipohja`,
'sb1494c08c8c720d1': `Aseta tekstin väri`,
'sb19611adbc88f711': `Edistynyt: Näytä lähdekoodin muokkauskomennot, esim. asiakirjan HTML:n näyttäminen tai mukautettujen tyylien ja komentosarjojen lisääminen.`,
'sb206d700d26b14ff': `Alleviivaa`,
'sb233557012dcb328': `Siirry alaspäin`,
'sb26035b596566abf': `Nimetön`,
'sb2cda80610c8d6ea': `Avaruus kaikki`,
'sb2dc787b0983ebc6': `Liettuan`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Keskusta`,
'sb3ba3276ae93627c': `Lisää esimuotoiltu tekstilohko`,
'sb430f5b4824de0d3': `Valitse ulkoasu`,
'sb43db07b24da018a': `Amharic`,
'sb45f9fb4dba6e71a': `Unset`,
'sb4e003a459464d85': `Kurdi`,
'sb4f0310e6787d098': `Uzbekistan`,
'sb4f1dffbb6be6302': `Kirkas`,
'sb51270e19988f9bd': `Alue`,
'sb59d621e3c93cc27': `Jaetut solurajat`,
'sb5e9e1776242b028': `Vuorovaikutukset`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Tohtorin tutkinto`,
'sb6103872073d369e': `Lisää tiedot`,
'sb616811735bfbafd': `Taulukon solu`,
'sb628960829e223bb': `Ohita kaikki päällekkäisyydet`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Soveltaa ja tuoda`,
'sb66e2181a7b5738a': `Ottamalla telemetrian käyttöön sallit tietojen keräämisen ja säilyttämisen seuraavien ohjeiden mukaisesti`,
'sb67e0e7c0869f982': `Ero`,
'sb68e83cda6c85af8': `Taulukon otsikko`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Koristeen paksuus`,
'sb70c17f7899f9b01': `Latinankielinen`,
'sb71941f552f3504d': `Aseta erityinen arvo`,
'sb740eab4afd5a710': `Verkon automaattinen virtaus`,
'sb741b6e0ca589122': `Palauta kerros`,
'sb7c77d0415de05cf': `Suorita testit`,
'sb7fb7568f6883ab8': `Jaa aktiivinen asiakirja`,
'sb85774dc5d18ff0f': `Vahvista`,
'sb85b1e36579852a6': `Virheellinen sähköpostiosoite tai salasana`,
'sb884fa76bfc55429': `Arabia`,
'sb8a3d4df7d1c5e6b': `Balance`,
'sb8f610a0e8df91fc': `Valovoima`,
'sb8f855b49234b81b': `Hae`,
'sb905da066c10182c': `Plus tummempi`,
'sb940ade1bd81be7e': `Vasemmalla`,
'sb9e9a7dd45966756': `Merkitse valinta lihavoiduksi`,
'sba509fd8ed61d1d5': `Tallentamaton tiedosto`,
'sba64d8954d027206': `Opasiteetti`,
'sba88d90cd6c751b3': `Sarakkeen sääntö`,
'sbaf0a7c417e388af': `Terveys`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Taustan suodatin`,
'sbb85a407d730e13d': `Lisää haku`,
'sbb86c6c96f598bb8': `Mixed`,
'sbba0156f795d8c07': `Muokkaa valintaa`,
'sbba865d4b437944f': `Attribuutti`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Poista`,
'sbc5f2a81604baf9b': `Otsake 6`,
'sbc5f2b81604bb14e': `Otsake 5`,
'sbc5f2c81604bb301': `Otsake 4`,
'sbc5f2d81604bb4b4': `Otsake 3`,
'sbc5f2e81604bb667': `Otsake 2`,
'sbc6953a36ced943f': `tietosuojakäytäntö`,
'sbd181cd54b8402a4': `Muokkaa valintaa`,
'sbd35ee879d9cf770': `Ruby teksti`,
'sbd40f40cbadd38d5': `Poista tämä widget-paketti`,
'sbd72dc858de95ce8': `Burman`,
'sbe3c60c65f129daa': `Humanistiset tieteet`,
'sbe4a7c8f231739b3': `tai liitä/pudota/poimi tiedosto`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Lisää rivinvaihto`,
'sbf00e1ee999ea94e': `Lisää komentosarja`,
'sbf519920c2017d67': `Ripustettu`,
'sbfa01f189a68d3e9': `Joustava kasvu`,
'sbff54e740c4086eb': `Näytä tuntemattomat paketit`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `Turkmenistan`,
'sc1611c0558728a2a': `Asema`,
'sc1a155cc25899250': `Taulukon riviryhmä`,
'sc1aa1f6051b7102a': `Romanian`,
'sc1edebeaef92b7bd': `Kiinteä taulukkoasettelu`,
'sc1fff4f356dfb2fb': `Muunnos`,
'sc221faca1ecb4aee': `Anonyymi`,
'sc24bda3c061fddf8': `Napsautettava alue`,
'sc252a4e091763606': `Lisää taulukon alatunniste`,
'sc2536e077514accc': `Vieritys`,
'sc275dd00036d16cb': `Lainaukset merkki`,
'sc28864200d2a3799': `Kopioi QR-koodi kuvana`,
'sc2a24a9dd41a9503': `Koristelulinja`,
'sc2b734cca2fa643b': `Pan (alas)`,
'sc2e2a0dbf03723b7': `Edistynyt: (Varoitus: Saattaa olla vaarallinen)`,
'sc3998b77d72c2932': `Lisää verkkosivusto (rivikehyksenä)`,
'sc3ac225273c8316b': `Yleistä`,
'sc3cfee84dbbf36ae': `Paikallinen tiedosto`,
'sc3f09a9b6fa4fbed': `Sisällä`,
'sc43767deea72e9f3': `Kuvausluettelo`,
'sc462bbdd36bcba6b': `Viite laatikko`,
'sc4ee3e4ee994dafd': `Ukrainan`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Näkökulman origo (y)`,
'sc52e8b794c0913d6': `Näkökulman origo (x)`,
'sc53de149fcaad713': `Hahmojen väliset`,
'sc546f489f9c0cced': `Vaihtaa aktiivisen asiakirjan testaustilan vaihtamalla`,
'sc5bcf50d1b578d9f': `Fonttiominaisuuden asetukset`,
'sc5cb39478b9b7625': `Merkitse valinta alaindeksiksi`,
'sc6415b50ff928294': `Luettelon kohde`,
'sc650ff15b20fe9d3': `Kierrä (z)`,
'sc6578b15b2154365': `Kierrä (x)`,
'sc65aff15b2183e58': `Kierrä (y)`,
'sc6da0f4a7e4d710e': `Fontin kielen ohitus`,
'sc74e3567875ce255': `Sekä widgetin tagi että NPM-paketin nimi.`,
'sc7eb080b96e244df': `Malaiji`,
'sc8ac7ef92b95df3f': `Siirrä (x)`,
'sc8af536e2084ade0': `Paletti`,
'sc8b022f92b992bc2': `Siirrä (y)`,
'sc8b39af92b9c2d81': `Siirrä (z)`,
'sc8d2c7f6c33a2b32': `Valittujen elementtien tekstityylin (kohdistus, sisennys, väli jne.) asettaminen.`,
'sc8fa0e3de389ef1c': `Fontin koon säätö`,
'sc9474bf7a0668d73': `Yhteenveto`,
'sc94e314312a8900c': `Tšekki`,
'sc980855a000b76ea': `Pohja`,
'sc98b103772de63f4': `Suomalainen`,
'sca7cfe2bef51b2a5': `Juuret`,
'sca7fed2bef53cb99': `Rooli`,
'scabe6ecee5e01fd2': `Maltalainen`,
'scace301a88231cce': `Upota`,
'scbc55f622ec078c1': `Näytä laatikko`,
'scbe537fc38ff4c13': `Ruudukon automaattiset sarakkeet`,
'scc1db59d292cbc4c': `Jakso`,
'scc56b218a2689c42': `Armenian`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Pehmustelaatikko`,
'scd9cedeb5ece3adb': `Kirjoitusmerkki`,
'scdf536b65be39ec5': ` Luo/tuo`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografinen`,
'sceecdd0bb404bc17': `Aseta valintaryhmä`,
'scf00d48fd5953a03': `Kreikan`,
'scf932840a69dbb7c': `Portugalin`,
'scf932a8577057752': `Alatunniste`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Alhaalla oikealla`,
'sd01178c54f648118': `Tasapainopylväät`,
'sd03bff50f87f82d4': `Yhdysmerkki`,
'sd05a155fe09c2866': `Verkossa, kun käytetään`,
'sd0864ea6cb6ef22e': `Yhteisö`,
'sd10fdbe6caf9a998': `Rivinvaihto`,
'sd121d3b959b7888d': `Optimoi nopeus`,
'sd1a78e667a1a139f': `Merkitse valinta lisäykseksi`,
'sd1cffad290ea5b3b': `Pidä kaikki`,
'sd1f10284eeb17b25': `Fidži`,
'sd1f44f1a8bc20e67': `Sähköposti`,
'sd1f81984eeb7c0e8': `Täytä`,
'sd29dc07235eea0f5': `Tarjouspyyntö`,
'sd2addf69477cd4b4': `Tuo paketti`,
'sd2ed26defc646d47': `Taustalla suodatin`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Korjattu`,
'sd3a288c1094b8a63': `Sarakkeen säännön leveys`,
'sd3c65ef5c380c046': `Inset`,
'sd3dcb76f7b28adb8': `Latvian`,
'sd3eca1e0f4209f6e': `Leikkaa kaikki`,
'sd3f402df8619ddcd': `Nämä sinua koskevat tiedot lisätään automaattisesti uusiin asiakirjoihin. Voit
          muuttaa tätä kunkin asiakirjan kohdalla metatietoeditorissa.`,
'sd4368b12645d3c0f': `Lisää portaali`,
'sd452cebf4a0313d1': `Näytä lähteen muokkauskomennot`,
'sd48cc52117f4d68b': `Italian`,
'sd52660ee947ca58b': `Lisää taulukon sarake`,
'sd588d17a1b25c220': `Tekstin ylivuoto`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Korkeakouluopetus.`,
'sd5cf95145e4d89ca': `Poista tämä pätkä`,
'sd5fd9d11a92f5b1d': `Alhaalla vasemmalla (y)`,
'sd60c9bbc51375635': `Lisää painike`,
'sd66c4767fa3dde28': `Korostusväri`,
'sd679c8b1bf8cc8a5': `Pienet yhtiöt`,
'sd7086c4425c53c80': `Fonttiperhe`,
'sd837f42ac7cbfb58': `Muoto (ulkopuolella)`,
'sd88076d2994ee0fb': `Poissulkeminen`,
'sd89a2e529b31ef43': `Palauta`,
'sd8a345e95668b73b': `Pystysuora, oikealta vasemmalle`,
'sd8ce9e57270b030d': `Fontin venytys`,
'sd8ecf227c7c49331': `Matemaattinen`,
'sd8f923198e0c5c6a': `End`,
'sd9c21e5f60d6bdd8': `Tanskalainen`,
'sd9ff8e2612e63d50': `Rajauslaatikon mitoitus`,
'sda2d76b976502a8d': `Avaa...`,
'sda344aacb837387e': `Sijainti säiliössä`,
'sda5b6fa8b771f996': `Float vasemmalle`,
'sda9254d1f1228e1a': `Unkarilainen`,
'sdb1595f5c742dfbb': `Tulo`,
'sdb711380a28fec75': `Lisää luettelo (järjestetty)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Alhaalla oikealla (y)`,
'sdc12d4d35420eeb7': `Kommentit`,
'sdc48456f9a27ae02': `Generaattori`,
'sdc70d81cf6c28533': `Georgian`,
'sdd1ff479d04ac140': `Julkinen`,
'sdd2fc8919a9c3111': `Taustan sekoitustila`,
'sdd35b688281b6dea': `Japanilainen`,
'sddc49047f66a64ab': `Ei kuvausta`,
'sdef34fe08bb28b09': `Kiinan kieli (yksinkertaistettu)`,
'sdf62e305e1594805': `Merkitse valinta ruby-merkinnällä`,
'sdf946172dfa0328f': `Ylinumero`,
'sdf9bc5d9b7f3e3de': `Kohdistus`,
'se036b53f145441cd': `Sekoitettu sisältö`,
'se06f459fccdc3ce9': `Kohdista viimeinen tekstirivi`,
'se0a782a8be8e018b': `Norjalainen`,
'se0cda6b80a1bb50f': `Slovakian`,
'se0f67eae944f8f94': `Mykistä`,
'se1312d6528f9a259': `Joruba`,
'se16c5e66886fbc59': `Artikkeli`,
'se1f5bb0386c88f96': `Asettaa valitun tekstin värin`,
'se219da7b1e955c65': `Selkeä muotoilu`,
'se25e4f2cb77b8be8': `WebWriter-käyttöliittymän kieli ja uudet asiakirjat`,
'se2796c5824ec8916': `Sisällön näkyvyys`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Anywhere`,
'se39c065efa467782': `Baskimaan`,
'se3b4c857f91f80d7': `Pikanäppäimet`,
'se47baf2fd16b9d2b': `Malli`,
'se48bd9e6c2a3109d': `Tilit`,
'se58467472725ad0c': `Kuvan resoluutio`,
'se58f06c2b0583ff7': `Valitse koordinaatit`,
'se5dc1e97fb743ade': `Välimatkat`,
'se619a501d1bfe6a5': `Kääri`,
'se62385ac082368d2': `Merkitse valinta viittauslähteeksi`,
'se6297163cac9d276': `Muokkaa lähdettä`,
'se633223a0b88625e': `Solun sijoittaminen`,
'se638417c560cfe5c': `Murtautua sisään`,
'se64f418b4e733b6c': `Lisää lähtö`,
'se79c0a3ac70d8fb3': `Asp. suhde (x)`,
'se79fae3ac710dc36': `Asp. suhde (y)`,
'se7fad370d8fb4cec': `Optimoi luettavuus`,
'se8a94b4effa2033e': `Aakkoset`,
'se95d4e55ea186d9a': `Vierityspalkin väri`,
'se96d43a515b8451c': `Slovenian`,
'se96fd76ba1b2975a': `Keskus`,
'se9ac05f36b004eb0': `Piilota esittelykierros. Poista käytöstä, jotta esittelykierros näytetään uudelleen.`,
'se9b1fec72ffd8f48': `Paikallinen`,
'sea24bdcaa2bd2dec': `Pakollinen napsahdus`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Vaihtaa metatietoeditorin`,
'sea896ed51ad33287': `Ei erityisiä tyylejä saatavilla`,
'seaaaeb09e3b4e78b': `Muokkauskomennot`,
'seabae79729c4b2ad': `Vaihda sähköpostia`,
'seaecc8267bad6234': `Keskikoulu`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Vältä saraketta`,
'seb4e52ef5ec7a7dc': `Värit/efektit`,
'seb8982ae8c3cdcc5': `Indonesialainen`,
'sebbced89e0db2894': `Ensimmäinen perustaso`,
'sec02109a0dd2a6c8': `Painotus väri`,
'sec2557a35b702525': `Muuttuva`,
'sec2da4aa7a02b925': `Islantilainen`,
'sec30fbb20f102670': `Lisää tiivistelmä`,
'sec8b0b6c729816b6': `Otsikkoryhmä`,
'seccd05955adb76bc': `Juliste`,
'sed17285cd25d6389': `Hakemisto, jossa package.json sijaitsee`,
'sed318ec045c5144f': `Over`,
'sed713f1b916fb469': `Reunaväli (x)`,
'sed74a31b9172942c': `Reunaväli (y)`,
'sed86bd0deb2e5372': `Muunna teksti`,
'see2fcaedf9743ec6': `Sijainti`,
'seec6798afe90ffc8': `Tulosta`,
'sef00c258bc1ecf1e': `Tässä tutkittavassa on tallentamattomia muutoksia.`,
'sef23dd271edd4a8b': `Alhaalla vasemmalla`,
'sef24caccbd4645ef': `Joustava kutistuma`,
'sef49aec68fd1dc66': `Nimi`,
'sef73fe18e351eb35': `Avainsanat`,
'sef75f458d77491af': `Vaihtoehtoryhmä`,
'sefcf950b3cc4fc3b': `Kieli`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Sisältö`,
'sf0cab2483f66aa2e': `Custom`,
'sf0e261e04eda82ff': `Ulkonäkö`,
'sf1045382c1fd9a85': `Tarkat painovärit`,
'sf14c35392ec7bf10': `Tämä ominaisuus ei ole käytettävissä Firefoxissa. Se on käytettävissä Chromessa tai Edgessä.`,
'sf14f9d5f9f6ca342': `Plus kevyempi`,
'sf1868dc19e3917bb': `Espanjan`,
'sf190149f9d8bbb2a': `Kirjoitustila`,
'sf1e79171c4856543': `Oletko varma? Tätä toimenpidettä ei voi peruuttaa, kaikki asetuksesi poistetaan ja
          nollataan.`,
'sf21c1f60c7515f44': `Merkitse valinta näytteeksi`,
'sf21fb4f4b9e8911f': `Leveys`,
'sf22a3737146ec910': `WebWriter voi upottaa SVG:n suoraan asiakirjaan.`,
'sf2514d5dc78b1654': `Lisää widget`,
'sf28903d4ca0ddcfc': `Poista tämä tili`,
'sf2ab37af0abc55ef': `Piilota esittelykierros`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Koon muuttaminen sekä vaaka- että pystysuunnassa`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `Animaation koostumus`,
'sf2de3dbe2108637a': `Muodon renderöinti`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Lisää raita`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Hylkää muutokset`,
'sf4849bc200e279ed': `Taulukon kuvateksti`,
'sf486ca1fdbe08645': `Lisää kuva`,
'sf4b537d4cbd8f5fd': `Teksti ylhäältä`,
'sf4e0e02a5277ef23': `Lisää tekstialue`,
'sf4f067d41efd4b83': `Mittakaava (y)`,
'sf4f3cbd41f002b46': `Mittakaava (x)`,
'sf4fa67d41f05a008': `Mittakaava (z)`,
'sf5197db2d5f2926a': `Pyöritä`,
'sf52d840949a980d1': str`
          ${0}
          poistetaan pysyvästi. Oletko varma? 
        `,
'sf55d634dcc743595': `Palvelut`,
'sf59c9081d106dd9c': `Merkitse valinta muuttujaksi`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Poista asiakirja`,
'sf65df67a03bebe4b': `Tarvitaan tätä widgettiä varten`,
'sf6673729c03ae999': `Nollaa WebWriter`,
'sf67571992e7dc88e': `Koko kausi`,
'sf6b4934598f7ed10': `Salli valinta`,
'sf6e1665c7022a1f8': `Salasana`,
'sf79e0d78b56444f1': `Inline-pääte`,
'sf7a5f7a7c80c3082': `Molemmat`,
'sf7c0eba7c822e3d6': `Rohkea`,
'sf86bd4d2982f3b74': `Merkitse valinta koodiksi`,
'sf8e82313fa411494': `Merkitse valinta linkiksi`,
'sf955eff73fb6b573': `Serbian`,
'sf9929e2d356260c5': `Kerrotaan`,
'sf993bb199fefbe04': `Kaikki`,
'sf9ecf969dd4b8164': `Molemmat reunat`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Yksityinen pääsy`,
'sfa59c7777e2a0eeb': `Tietoluettelon lisääminen`,
'sfaa0a67db5c11f72': `Ensimmäisen tekstirivin sisennys`,
'sfb231a52211b133f': `Ei tekstin käärimistä`,
'sfb68cae41d749423': `Alkuperäinen`,
'sfb9b6edb0ed378c9': `Viittauslähde`,
'sfbbab09dbe553571': `Vektoripiirroksen (SVG) lisääminen`,
'sfc00292e778b67e2': `Mittari`,
'sfc63e31ac7c956ed': `Valitse`,
'sfc815c9078bba30a': `Lataa QR-koodi kuvana`,
'sfcdd8e672c75b713': `Osoite`,
'sfcebd18506f1e535': `Virtaus`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Lähtö`,
'sfdb1e4d90981a535': `Jaa tämä asiakirja`,
'sfdeef3dccf409f81': `Tämä avainsana tarvitaan widgettejä varten`,
'sfe6e758ad2603c1d': `Maisterin`,
'sfee1c12daf838935': `Väri palaa`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Lisää valintaikkuna`,
'sffa395f64ec6ac36': `Bulgarian`,
'sffdadf0a576fd802': `Korkeus`,
'spaceKey': `Avaruus`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Ylös`,
    };
  